import React from "react";

export default class PromenaPina extends React.Component {
	constructor(props) {
		super(props);
		this.state = { pin: null };
	    this.handleChange = this.handleChange.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
	}

    handleFormSubmit(e) {
      e.preventDefault();   
        if(this.state.pin !== null ){
        this.props.putPromeniPin(this.props.idFirme,this.state.pin)
        }else{

        }
    }

        handleChange(e) {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

	render() {
		return (
			<div >
                <div className="center_nr">
                    <div className="card_nr">
                      
                        <form onSubmit={this.handleFormSubmit}>
                            <input
                                className="form-item_nr"
                                placeholder={this.props.pinFirme}
                                name="pin"
                                type="text" pattern="[0-9]*"
                                onChange={this.handleChange}
                                title="Pin ne sme sadržati slova i znakove!"
                            />
                            <input
                                className="form-submit_nr"
                                value="Promeni"
                                type="submit"
                            />
                        </form>
                    </div>
                </div>
            </div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/Moduli/PromenaPina.js